import { render, staticRenderFns } from "./PrivilegeList.vue?vue&type=template&id=60b1a0fe&scoped=true&"
import script from "./PrivilegeList.vue?vue&type=script&lang=js&"
export * from "./PrivilegeList.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeList.vue?vue&type=style&index=0&id=60b1a0fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1a0fe",
  null
  
)

export default component.exports